import { render, staticRenderFns } from "./VueJsoneditor.vue?vue&type=template&id=472ae874&scoped=true&lang=html&"
import script from "./VueJsoneditor.vue?vue&type=script&lang=js&"
export * from "./VueJsoneditor.vue?vue&type=script&lang=js&"
import style0 from "./VueJsoneditor.vue?vue&type=style&index=0&id=472ae874&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472ae874",
  null
  
)

export default component.exports